import {AbsolutePath} from './paths';

export function makeRelative(absolutePath: AbsolutePath): string {
  return absolutePath.substring(1); // Strip off leading /
}
